import { JsonProperty } from "../../../models/utilities/json-property";
import { ShipmentType } from "../enums/_index";
import { ShipmentStatus } from "../enums/shipment-status";
import { BackhaulShipmentAction, DeliveryShipmentAction, EndShipmentAction, ShipmentAction, StartShipmentAction } from "./shipment-action";

export const shipmentActionMapper = (type : any) => {

    // Origin = 0,
    // CustomerDelivery = 1,
    // Backhaul = 2,
    // Destination = 3

    switch (type) {
        case 0: 
            return StartShipmentAction;
        case 1:
            return DeliveryShipmentAction;
        case 2:
            return BackhaulShipmentAction;
        case 3:
            return EndShipmentAction;
        default:
            return {};
    }

};

export class ShipmentRead {

    public type : ShipmentType = ShipmentType.Truck;

    public id : number = 0;
    
    public name : string = '';

    public status : ShipmentStatus = ShipmentStatus.Open;
    
    public serviceCenterId : string = '';

    @JsonProperty({ toType: 'date' })
    public cutoffDate : Date|undefined = undefined;

    @JsonProperty({ enumMapper: shipmentActionMapper, enumProp: 'type', designType: 'array' })
    public actions : ShipmentAction[] = [];    

    @JsonProperty({ toType: 'datetime' })
    public createdOn : Date = new Date();
    
    @JsonProperty({ toType: 'datetime' })
    public lastModified : Date = new Date();
    
    public rowVersion : string = '';

    public note : string = '';

    // Display purposes only, mapped in the service
    public waypoints : any[] = [];

}
